import { ChangeDetectorRef, Component, Inject, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonHelper } from '../../../utilities/common.helper';
import { LoaderService } from '../../sharedServices/loader.service';
import { SharedService } from '../../sharedServices/shared.service';
import { addressDto, contactDtos, DesDegreeDtos, EducationDtos, ProfileDto } from './model/admin-personal-details.models';
import moment from 'moment';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { DocumentViewerComponent } from '../modal/document-viewer/document-viewer.component';
import { PdfViewerComponent } from '../modal/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'kt-admin-personal-details',
  templateUrl: './admin-personal-details.component.html',
  styleUrls: ['./admin-personal-details.component.scss']
})
export class PersonalDetailsAdminComponent implements OnInit {
  public personalDetails: any = new ProfileDto();
  public contactDetails: any = [];
  public documentColumns: Array<any> = new Array<any>();
  public documentList: Array<any> = new Array<any>();
  public appDocumentList: Array<any> = new Array<any>();
  @ViewChild('actionsDocumentTemplate', { static: true }) actionsDocumentTemplate: TemplateRef<any>;
  @ViewChild('actionsVerificationDocumentTemplate', { static: true }) actionsVerificationDocumentTemplate: TemplateRef<any>;
  
  public contactDetailsDto: any = new contactDtos();
  public addressDetails: any = new addressDto();
  public educationDetails: any = [];
  public educationDetailsDtos: any = new EducationDtos();
  public desDegreeDetails: any = [];
  public desDegreeDetailsDtos: any = new DesDegreeDtos();
  public commonProfileId:any;
	public columns: Array<any> = new Array<any>();
  public eduColumns:Array<any> = new Array<any> ();
  public modeofStudy = [
    { label: 'On Campus', value: 6003601 },
    { label: 'Distance Learning/Online study', value: 6003602 },
    { label: 'Blended Learning', value: 6003603 },
    { label: 'At approved institution/Centre in Pakistan.', value: 6003604 },
  ];

  public degreeObtainedByTypes = [
    { label: 'Course Work', value: 6003801 },
    { label: 'Research Method', value: 6003802 },
    { label: 'Both', value: 6003803 },
  ];

  public SessionTypes = [
    { label: 'Part Time', value: 6003701 },
    { label: 'Full Time', value: 6003702 }
  ];
  public loading:boolean = false;
  uniVerificationDocList: any[] = [];
  verficationDocumentColumns: Array<any> = new Array<any>();
  
  finalLetterDocumentList: any[]=[];
  constructor(private dialogRef: MatDialogRef<PersonalDetailsAdminComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private sharedServices: SharedService, private cdr: ChangeDetectorRef,
    private matDialog: MatDialog,) { }

  async ngOnInit() {
    console.log(this.data)   
    this.generateDocumentColumns();
    this.generateColumns();
    // CommonHelper.valuesFromFormToModel(this.personalDetails, this.data.details.personalDetail)
    let personalDetails = {...this.data.details}
    // this.personalDetails = this.data.details
    delete personalDetails.desDegree
    delete personalDetails.selectedEducationList
    delete personalDetails.questionnaireDone
    delete personalDetails.commonProfileId
    delete personalDetails.statusId
    delete personalDetails.id
    personalDetails.challanDate = moment(personalDetails.challanDate).format('DD-MM-YYYY');
    personalDetails.applicationSubmitDate = moment(personalDetails.applicationSubmitDate).format('DD-MM-YYYY');
    this.personalDetails = CommonHelper.convertObjToArray(personalDetails);
    this.commonProfileId = this.data.details.commonProfileId
    console.log(this.data.details)
    let eduData = this.data.details.selectedEducationList 
    eduData.forEach(element => {
      delete element.desDegree
      CommonHelper.valuesFromFormToModel(this.educationDetailsDtos, element.educationHistory)
      this.educationDetails.push(this.convertObjToArray(this.educationDetailsDtos))

    });
    let desData = this.data.details.desDegree
    desData.forEach(element => {
      element.certificateInEnglish = element.certificateInEnglish ? 'Yes':'No';
      element.isAnnual = element.isAnnual ? 'Yes':'No';
      element.isProvisional = element.isProvisional ? 'Yes':'No';
      element.linkAvailable = element.linkAvailable ? 'Yes':'No';
      element.uniVerificationAvailable = element.uniVerificationAvailable ? 'Yes':'No';
      element.noOfStudyMonths = element.noOfRegularSemester;
      CommonHelper.valuesFromFormToModel(this.desDegreeDetailsDtos, element)
      this.desDegreeDetails.push(this.convertObjToArray(this.desDegreeDetailsDtos))

    });    
    await this.getDocuments('CMNPROF', this.commonProfileId)
    await this.getDocuments('DESF', this.data.details.id)
    if(this.data.isDesf)
    {
    await this.getDesfVerificationDocs(this.data.details.id)
    await this.getDocuments('DESF_FLP', this.data.details.id)
    }
  }

  generateDocumentColumns(): void {
    this.documentColumns = [
      { name: 'title', displayName: 'Document Title' },
      { name: 'createdDate', displayName: 'Uploaded Date' },
      { name: 'action', displayName: 'Action', cellTemplate: this.actionsDocumentTemplate }
    ];

    this.verficationDocumentColumns = [
      { name: 'title', displayName: 'Document Title' },
      //{ name: 'createdDate', displayName: 'Uploaded Date' },
      { name: 'action', displayName: 'Action', cellTemplate: this.actionsVerificationDocumentTemplate }
    ];
  }

  getDocuments(acronym, id): void {
    const payload = {
      data: {
        applicationId: id,
        processAcronym: acronym
      }
    }
    this.sharedServices.getDocumentList(payload)
      .subscribe(response => {
        if (response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if(acronym == 'CMNPROF'){
          if (response.data && response.data.length > 0) {
            response.data.forEach(doc => {
              doc.title = doc.title + ' - ' + doc.description
              doc.createdDate = moment(doc.createdDate).format('DD-MM-YYYY')
              this.documentList.push(doc)
            });
            this.cdr.detectChanges();
            console.log(this.documentList)
          }
        }
        else if(acronym == 'DESF_FLP'){
          if (response.data && response.data.length > 0) {
            response.data.forEach(doc => {
              doc.title = doc.title + ' - ' + doc.description
              doc.createdDate = moment(doc.createdDate).format('DD-MM-YYYY')
              this.finalLetterDocumentList.push(doc)
            });
            this.cdr.detectChanges();
            console.log(this.finalLetterDocumentList)
          }
        }
        else{
          if (response.data && response.data.length > 0) {
            response.data.forEach(doc => {
              doc.title = doc.title + ' - ' + doc.description
              doc.createdDate = moment(doc.createdDate).format('DD-MM-YYYY')
              this.appDocumentList.push(doc)
            });
            this.cdr.detectChanges();
          }
        }
        } else {
        }
        // this.loaderService.setValue(this.loading)
        this.cdr.detectChanges();


      }, error => {
        // this.loaderService.setValue(this.loading)
        this.cdr.detectChanges();

      });
  }


  public convertObjToArray(data) {
    let x = Object.keys(data)
    let y = Object.values(data)
    let combinedArray = []
    for (let i = 0; i < x.length; i++) {
      combinedArray.push({
        label: CommonHelper.convertCamelCaseToSentence(x[i]),
        value: y[i]
      })
    }
    return combinedArray;
  }

  public convertToString(str) {

    const result = str.replace(/([A-Z])/g, ' $1');

    const final = result.charAt(0).toUpperCase() + result.slice(1);

    return final;
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public getValues(value, label) {
    if (label == 'End Date' || label == 'Start Date') {
      let date = moment(moment(new Date(value))).format('DD-MM-YYYY')
      return date;
    } else if (label == 'Mode Of Study') {
      return this.modeofStudy.find(data => data.value == value) && this.modeofStudy .find(data => data.value == value).label
    } else if (label == 'Degree Obtained By') {
      return this.degreeObtainedByTypes.find(data => data.value == value) && this.degreeObtainedByTypes.find(data => data.value == value).label
    } else if (label == 'Session Type') {
      return this.SessionTypes.find(data => data.value == value) && this.SessionTypes.find(data => data.value == value).label
    }
    else {
      return value
    }
  }

  downloadDocument(document,type): void {
		console.log(document)
		this.loading = true;
		const payload = {
			data: {
				documentId: document.documentId,
				acronym: document.acronym ? document.acronym : 'CMNPROF'
			}
		}
		this.sharedServices.getAttachmentByDocumentId(payload)
			.subscribe((response:HecResponse) => {
				if (response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					if (response['data']) {
						this.loading = false;
						// this.loaderService.setValue(this.loading)
						this.cdr.detectChanges();
						if(type == HEC_CONSTANTS.DOCUMENT_CLICKED_TYPE.VIEW){
						if (response.data.path.toLowerCase().split('.').pop() != 'pdf') {
              let pdfWindow = window.open("")
                pdfWindow.document.write(
                    "<img src='data:image/" +response.data.path.toLowerCase().split('.').pop()+";base64,"+
                    encodeURI(response.data.content) + "'/>"
                )
              // window.open("data:image/"+response.data.path.toLowerCase().split('.').pop()+';base64,' + encodeURI(response.data.content)); 
							// this.ModalComponent(DocumentViewerComponent, response.data.path.toLowerCase().split('.').pop(), response.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-two')
						  } else {
                let pdfWindow = window.open("")
                pdfWindow.document.write(
                    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                    encodeURI(response.data.content) + "'></iframe>"
            )
              // window.open("data:application/pdf;base64," + encodeURI(response.data.content)); 
							// this.ModalComponent(PdfViewerComponent, response.data.path.toLowerCase().split('.').pop(), response.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-three')
						  }
						}else{
							this.saveFile(response.data.content,document,response.data.path.toLowerCase().split('.').pop())
						  }
					}
				} else {
					this.loading = false;
					// this.loaderService.setValue(this.loading)
					this.cdr.detectChanges();
					// this.isError = true;
					// this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					// this.errorMessage = response.statusDescription;;
				}
				this.loading = false;
				// this.loaderService.setValue(this.loading)
				this.cdr.detectChanges();


			}, error => {
				// this.isError = true;
				// this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
				// this.errorMessage = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR;
				this.loading = false;
				// this.loaderService.setValue(this.loading)
				this.cdr.detectChanges();

			});
	}

  private saveFile(base64, fileData,fileType) {
		const base_64 = base64.substring(base64.indexOf(',') + 1);
		const contentType = fileType;
		const fileName = fileData.fileName ? fileData.fileName : fileData.title;
		const fileExt = '.' + contentType.substring(contentType.indexOf('/') + 1);
	
		const blob = CommonHelper.base64toBlob(base_64, contentType);
		const blobUrl = URL.createObjectURL(blob);
	
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		  window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
		}
		else {
		  let a = document.createElement('a');
		  a.href = blobUrl;
		  a.download = fileName + fileExt;
		  document.body.appendChild(a);
		  a.click();
		  document.body.removeChild(a);
		}
	  }


  public ModalComponent(component, imageType, imageContent, backdropClass?, panelClass?) {
		const dialogRef = this.matDialog.open(component, {
		  width: '70vw',
		  height: '60vh',
		  backdropClass: backdropClass,
		  panelClass: panelClass,
		  disableClose: true,
		  autoFocus: false,
		  data: { imageType: imageType, imageContent: imageContent }
		});
	  }

    generateColumns(): void {
      this.columns = [
        { name: 'contactType', displayName: 'Contact Type' },
        {name:'contactValue',displayName:'Contact Value'},
        { name: 'countryDialingCode', displayName: 'Country Dialing Code' },
        { name: 'countryName', displayName: 'Country Name' },
      ];

      this.eduColumns = [
        { name: 'qualificationLevel', displayName: 'Qualification Level' },
        { name:'countryValue',displayName:'Country of Study'},
        { name: 'uniName', displayName: 'University Name' },
        { name: 'exactDegreeName', displayName: 'Degree Program Name' },
        { name: 'campus', displayName: 'Campus Name' },
        { name: 'rollNo', displayName: 'Register/Roll Number' },
      ]
    }

    
	public getDesfVerificationDocs(applicationId):void{
		this.sharedServices.getVerificationFiles(applicationId).subscribe(
			(res)=>{
				if(res.statusCode == 200){
					this.uniVerificationDocList = []
				//	this.generateUniVerificationColumns();
					if(res.data){
					res.data.forEach(element => {
						this.uniVerificationDocList.push({title:element})
					});
          console.log(this.uniVerificationDocList)
				}
      
				}
			}
		)
	}
  public downloadverificationDocument(data):void{

		this.loading = true
		// this.loaderService.setValue(this.loading);
		this.sharedServices.getAttachmentDesfAdmin(this.data.details.id, data.title).subscribe(
			(res)=>{
				this.loading = false
				this.cdr.detectChanges()
				let url = window.URL.createObjectURL(res);
				let a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = data.title;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove();
				// this.loaderService.setValue(this.loading);
			}
		)
	}
}
